import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import couponUsageService from "../../services/couponUsageService";

// Initial state
const initialState = {
  usages: [],
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  totalPages: 0,
  currentPage: 1,
  totalCount: 0,
};

// Async thunks
export const fetchCouponUsages = createAsyncThunk(
  "couponUsages/fetchAll",
  async (params, { rejectWithValue }) => {
    try {
      return await couponUsageService.getCouponUsages(params);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch coupon usages"
      );
    }
  }
);

// Coupon usage slice
const couponUsageSlice = createSlice({
  name: "couponUsages",
  initialState,
  reducers: {
    clearCouponUsageError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch coupon usages
      .addCase(fetchCouponUsages.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCouponUsages.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.usages = action.payload.usages || [];
        state.totalPages = action.payload.totalPages || 1;
        state.currentPage = action.payload.currentPage || 1;
        state.totalCount = action.payload.totalCount || 0;
      })
      .addCase(fetchCouponUsages.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearCouponUsageError } = couponUsageSlice.actions;
export default couponUsageSlice.reducer;
